import clsx from 'clsx';
import { LuChartBar } from 'react-icons/lu';
import { RoundButton, RoundButtonProps } from './RoundButton';

export const RoundProgressButton = ({
  size = 'md',
  ...props
}: RoundButtonProps) => (
  <RoundButton size={size} {...props}>
    <LuChartBar
      className={clsx(
        size === 'xs' && 'text-4xl',
        size === 'sm' && 'text-4xl',
        size === 'md' && 'text-6xl',
        size === 'lg' && 'text-8xl',
      )}
    />
  </RoundButton>
);
